import { ConfigProvider, Drawer } from 'antd';
import styled from 'styled-components';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Box, Button, Col, Colors, IcIp, IcOperatingSystem, IcResolution, Row, Text } from 'basic-ui-lib';
import BaseInput from 'basic-ui-lib/components/Input/BaseInput';
import { IDevice } from 'modules/dashboard/interfaces/api';
export interface DeviceInfoMobileModalRef {
  open: (deviceInfo: IDevice) => void;
}

interface DeviceInfoMobileModalProps {
  onSuccess: () => void;
}

const DeviceInfoMobileModal = forwardRef<DeviceInfoMobileModalRef, DeviceInfoMobileModalProps>(({ onSuccess }, ref) => {
  const [open, setOpen] = useState(false);
  const [deviceInfo, setDeviceInfo] = useState<IDevice | null>(null);

  useImperativeHandle(ref, () => ({
    open: (info) => {
      setOpen(true);
      setDeviceInfo(info);
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setDeviceInfo(null);
  };

  const handleOk = () => {
    onSuccess();
    handleClose();
  };

  return (
    <ConfigProvider>
      <StyledDrawer
        title={
          <DrawerHeader>
            <Text title_h6 semibold center>
              Device Information
            </Text>
          </DrawerHeader>
        }
        placement='bottom'
        closable={false}
        onClose={handleClose}
        open={open}
        height='85%'
        footer={
          <Row>
            <Button type_cancel lg onClick={handleClose} style={{ width: '100%' }}>
              Close
            </Button>
            <Button type_second lg style={{ width: '100%' }} onClick={handleOk}>
              OK
            </Button>
          </Row>
        }
        destroyOnClose
        style={{ borderRadius: '10px 10px 0px 0px' }}
      >
        <Col gap={4}>
          <Text body_1 medium color='neutral.text.3' left>
            DEVICE NAME
          </Text>
          <BaseInput value={deviceInfo?.deviceName || ''} readOnly />
        </Col>
        <Col>
          <Text body_1 medium color='neutral.text.3' left>
            DEVICE DETAILS
          </Text>
          <Box backgroundColor={Colors.neutral.bg[1]} borderRadius={24} border={'1px solid #F1F5F9'} boxShadow='0 1px 2px 0 rgba(0, 0, 0, 0.05)'>
            <Row className='box-info' padding={20}>
              <Box className='box-icon'>
                <IcOperatingSystem width={20} height={20} />
              </Box>

              <Col gap={4}>
                <Text caption_3 regular color='neutral.text.3' caplock left>
                  Operating System
                </Text>
                <Text content_2 semibold left>
                  {deviceInfo?.operatingSystem || 'N/A'}
                </Text>
              </Col>
            </Row>
            <Row className='box-info' padding={20}>
              <Box className='box-icon'>
                <IcResolution width={20} height={20} />
              </Box>

              <Col gap={4}>
                <Text caption_3 regular color='neutral.text.3' caplock>
                  Resolution
                </Text>
                <Text content_2 semibold left>
                  {deviceInfo?.resolution || 'N/A'}
                </Text>
              </Col>
            </Row>
            <Row className='box-info' padding={20}>
              <Box className='box-icon'>
                <IcIp width={20} height={20} />
              </Box>

              <Col gap={4}>
                <Text caption_3 regular color='neutral.text.3' caplock left>
                  Ip Address
                </Text>
                <Text content_2 semibold left>
                  {deviceInfo?.ipAddress || 'N/A'}
                </Text>
              </Col>
            </Row>
          </Box>
        </Col>
      </StyledDrawer>
    </ConfigProvider>
  );
});

DeviceInfoMobileModal.displayName = 'DeviceInfoMobileModal';
export default DeviceInfoMobileModal;

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 16px 16px 32px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: ${Colors.neutral.bg[2]};
  }

  .ant-drawer-footer {
    padding: 16px 16px;
    box-shadow: 0px -4px 8px 0px #0000001a;
    background-color: ${Colors.neutral.bg[1]};
  }

  .box-info {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .box-icon {
    width: 48px;
    height: 48px;
    border-radius: 16px;
    background-color: ${Colors.neutral.bg[2]};
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const DrawerHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
